module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-list', [_vm._l((_vm.items), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "to": item.route
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "light": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-list-tile', {
    staticClass: "hidden-sm-and-up",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("account_box")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.$t('logout'))
    }
  })], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f34aaa0e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMenu.vue
// module id = Dbte
// module chunks = 1